/** A map used to map ant design's table sorter into strapi sort string */
export const antToStrapiSorterMap = {
  ascend: "ASC",
  descend: "DESC",
};
